export enum ParamType {
  RowLimitPatientSearch = 1,
  PetitionSearchType = 2, //"Bsqueda peticiones, ver 0:Mdico, 1:Servicio, 2:Destino",
  ShowDatesInPatientRequests = 3, // "Ver Citas en Peticiones Paciente. 0=No; 1=Si",
  MedicalValidation = 4,
  SearchRequestsNumberOfDays = 5, // "Bsqueda peticiones, nmero de das por defecto.",
  SearchRequestsMaxDays = 6, //"Bsqueda peticiones, nmero mximo de dis.",
  MicroValidation = 7, //"Validacin Mdica micro: 0=Muestro todo; 1=Definitivo/Provisional; 2=Slo Definitivo",
  TextToUseInPendingResults = 8, //"Texto a sacar en resultados pendientes",
  Checked = 9, //"Revisado (0=No; 1=Si)",
  PrintDate = 10, // "Fecha Impresion (0=Ausgdat; 1=Info4)",
  ColorPatologico = 12, // "Color Patologico",
  ColorAlarma = 13, // "Color Alarma",
  ColorExtremo = 14, // "Color Extremo",
}

export interface IParameter {
  paramType: ParamType;
  value: string;
}
